export class Store
{
	#data;
	#listeners;

	constructor()
	{
		this.#data = new Map();
		this.#listeners = {};
	}

	addChangeListener(name: String, listener: Function)
	{
		if ((listener instanceof Function) === false)
		{
			throw new Error('Listener must be `Function` type');
		}

		this.#listeners[name] = this.#listeners[name] ?? new Set;
		this.#listeners[name].add(listener);
	}

	#callListeners(name: String, value)
	{
		const listeners = this.#listeners[name];
		if (listeners instanceof Set)
		{
			listeners.forEach((listener) => {
				listener(value, name, this);
			});
		}
	}

	get(name: String)
	{
		return this.#data.get(name);
	}

	set(name: String, value)
	{
		this.#data.set(name, value);
		this.#callListeners(name, value);
	}
}
